var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParallelChartPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 42,
    viewBox: "0 0 80 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28418 2.34094L39.4998 17.0908L76.3746 7.87216",
    stroke: "#CF797B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95459 20.443L40.1702 25.1361L77.045 21.1134M1.95459 36.5338L40.1702 35.1929L77.045 25.1361",
    stroke: "#A88E6F",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28418 1V40.3341",
    stroke: "#338ECC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6189 2.07251V39.9763",
    stroke: "#338ECC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7156 2.07251V39.9763",
    stroke: "url(#paint0_linear_2781_406689)",
    strokeWidth: 4,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2781_406689",
    x1: 78.2156,
    y1: 2.07251,
    x2: 78.2156,
    y2: 39.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D04F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9734"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelChartPlaceholder);
export default __webpack_public_path__ + "static/media/parallel-chart-placeholder.234ef0c5b220ef2a5a6fa5bafff173f7.svg";
export { ForwardRef as ReactComponent };